import React, { useEffect, useRef, useState } from "react"
import Modal from "react-modal"
import "./styles.scss"
import { ButtonClose } from "../ChatCloseButton";


function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return windowDimensions;
}


export function NewModal({
  children,
  defaultLoadingMessage,
  modalIsOpen,
  closeModal,
  hasButtonClose,
  message,
  alertType,
  width,
  hasModalDown = false,
  shouldCloseOnOverlayClick,
}) {

  const [isScrollable, setIsScrollable] = useState(false);
  const [container, setContainer] = useState(null);
  const containerRef = useRef(container);
  containerRef.current = container;

  const { height } = useWindowDimensions()

  useEffect(() => {
    if(containerRef.current?.clientHeight < height){
      setIsScrollable(true)
    }
    else {
      setIsScrollable(false)
    }
  }, [height, containerRef.current?.clientHeight])

  return (
    <>
      <Modal
        isOpen={modalIsOpen}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
        onRequestClose={closeModal}
        ariaHideApp={false}
        onAfterOpen={() => {}}
        backdropOpacity={2}
        contentRef={(element) => {
          if (!element) return;
          setContainer(element)
        }}
        className={
          hasModalDown ? "react_portal_custom-trello  react_portal_custom--hasdown" : isScrollable ? "react_portal_custom-new modal_scroll" : "react_portal_custom-new"
        }
        overlayClassName={
          hasModalDown
            ? "react_portal_custom-overlay react_portal_custom-overlay--hasdown"
            : "react_portal_custom-overlay"
        }>
        <div className="modal-panel__button">
          {hasButtonClose && (
           <ButtonClose handleClick={closeModal} />
          )}
        </div>
        <div className="modal-content" style={{ width: width }}>
          {children ? (
            children
          ) : (
            <>
              <div className="modal-panel__content-icon">{renderIcon(alertType)}</div>
              <div className="modal-panel__content-title">
                <h2>{renderMessage(alertType)}</h2>
              </div>
              <div className="modal-panel__content-submessage">
                <h2>{renderSubMessage(alertType, message, defaultLoadingMessage)}</h2>
              </div>
            </>
          )}
        </div>
      </Modal>
    </>
  )
}

export function NewModalHeader({ title, children, closeModal, buttonCloseDisabled, line = true }) {
  return (
    <div className={`modal-header ${line ? "" : "no-line"}`}>
      {title && !children ? <h3 className="modal-title">{title}</h3> : <div className="modal-header__content">{children}</div>}
      {closeModal && (
         <ButtonClose handleClick={closeModal} />
      )}
    </div>
  )
}

export function NewModalBody({ children, className, bodyClassName, styles, ref, hideScroll = false }) {
  return (
    <div className={`modal-body${hideScroll ? " hide-scroll" : ""}${bodyClassName ? " " + bodyClassName : ""}`}>
      <div ref={ref} className={`content-modal${className ? " " + className : ""}`} style={styles}>
        {children}
      </div>
    </div>
  )
}

export function ModalDouble({ title, children, position, className, noPadding, noBorderTitle }) {
  return (
    <div
      className={`content-modal--${position}${className ? " " + className : ""}`}
      style={noPadding && { padding: 0 }}>
      {title && (
        <div className={`content-modal__header${noBorderTitle ? " " + "no-border" : ""}`}>
          <h2>{title}</h2>
        </div>
      )}
      {children}
    </div>
  )
}

export function NewModalFooter({ children, className, styles, ...props }) {
  return (
    <div {...props} className={`modal-footer${className ? " " + className : ""}`}>
      {children && (
        <div className="modal-footer__content" style={styles}>
          {children}
        </div>
      )}
    </div>
  )
}